import { Button, CategoryCard, MediaQueries } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledSeeMoreButton = styled(Button)``

export const StyledRelatedCategoriesList = styled.div`
  ${StyledSeeMoreButton}[data-color='ghost'] {
    flex-shrink: 0;
    padding: 0 0 0 1em;
  }
`

export const StyledRelatedCategoriesContainer = styled.div`
  margin-bottom: 1em;
`
export const StyledCategoryCard = styled(CategoryCard)`
  display: inline-flex;
  width: calc((100% - 1rem) / 3);
  height: calc((100vw - 3rem) / 3 * 1.15);
  padding: 0.5rem;
  margin-right: 0.5rem;
  cursor: pointer;
  &.last-category-card {
    margin-right: 0;
  }
  div.banner {
    position: relative;
    height: 60%;
    margin-bottom: 0.5rem;
  }
  div.content {
    p {
      display: -webkit-box;
      overflow: hidden;
      height: 100%;
      align-items: center;
      justify-content: center;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-height: 1.2;
    }
  }

  ${MediaQueries.mbUp} {
    width: calc((100% - 3rem) / 3);
    height: 185px;
    margin-right: 1.5rem;
    div.banner {
      margin-bottom: 1rem;
    }
    div.content {
      p {
        font-size: 1rem;
      }
    }
  }
`
